import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { MAP_LIST, VENUE } from '../../utils/constants';
import { copyToClipboard } from '../../utils/functions';
import IconCopy from '../svg/IconCopy';
import Button from '../common/Button';

const MapSection = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const initializeMap = () => {
      if (window.naver && window.naver.maps) {
        const { naver } = window;
        const position = new naver.maps.LatLng(33.5107, 126.5192);
        const mapOptions = {
          center: position,
          zoom: 18,
          maxZoom: 18,
          minZoom: 18,
          origin: new naver.maps.Point(0, 0),
        };

        if (mapRef.current) {
          const map = new naver.maps.Map(mapRef.current, mapOptions);
          const marker = new naver.maps.Marker({
            map,
            position: position.destinationPoint(-5, 15),
            icon: {
              url: './marker.png',
              scaledSize: new naver.maps.Size(80, 80),
              origin: new naver.maps.Point(0, 0),
              anchor: new naver.maps.Point(40, 40),
            },
          });
        }
      } else {
        console.error('Naver Maps API가 로드되지 않았습니다.');
      }
    };

    const timer = setTimeout(() => {
      initializeMap();
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <StyledSection id="venue">
      <h2>오시는 길</h2>
      <strong>{VENUE.name}</strong>
      <StyledDiv>
        <p>{VENUE.address}</p>
        <StyledCopyButton
          type="button"
          onClick={() => copyToClipboard(VENUE.address)}
        >
          <IconCopy />
          주소 복사
        </StyledCopyButton>
      </StyledDiv>
      <StyledMapDiv ref={mapRef} id="map"></StyledMapDiv>
      <StyledUl>
        {MAP_LIST.map((map) => (
          <li key={map.id}>
            <Button
              href={map.link}
              sizeType="small"
              target="_blank"
              rel="noopener noreferrer"
            >
              {map.name}
            </Button>
          </li>
        ))}
      </StyledUl>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
  text-align: center;

  & > h2,
  & > strong {
    font-size: 1.8rem;
    line-height: 2.4rem;
    font-weight: 600;
  }

  & > strong {
    font-size: 1.6rem;
    margin: 2rem 0 0.5rem;
  }
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  font-family: var(--pretendard);
  font-size: 1.4rem;
  line-height: 1.4rem;
`;

const StyledCopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 1.2rem;
  color: var(--grayLv3);

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  &:hover {
    color: var(--grayLv4);

    path {
      fill: var(--grayLv4);
    }
  }
`;

const StyledMapDiv = styled.div`
  margin: 3rem 0;
  min-height: 25rem;
  background: var(--grayLv1);
`;

const StyledUl = styled.ul`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export default MapSection;
